import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core"
import React, { useEffect, useState } from "react"
import useSEO from "../components/Shared/useSEO"

const useStyles = makeStyles(theme => ({
  textField: {
    marginBottom: theme.spacing(2),
  },
  card: {
    margin: `
    ${theme.spacing(2)}px 
    0 
    ${theme.spacing(2)}px 
    0`,
    padding: `
    ${theme.spacing(2)}px 
    ${theme.spacing(4)}px 
    ${theme.spacing(2)}px 
    ${theme.spacing(4)}px`,
    border: theme.spacing(1),
    borderStyle: "solid",
    borderRadius: 0,
    borderColor: theme.palette.primary.main,
  },
  title: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  button: {
    "&.Mui-disabled": {
      color: theme.palette.common.white,
    },
  },
}))

type SendingState = "initial" | "sending" | "done"
const initialState = { name: "", email: "", body: "" }

export default function Contact() {
  useSEO({ title: "Kontakt" })
  const [sendingState, setSendingState] = useState<SendingState>("initial")
  const [formState, setFormState] = useState<typeof initialState>(initialState)

  const classes = useStyles()

  const handleFormFieldChange = (
    ev: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setFormState(prev => {
      return { ...prev, [ev.target.id]: ev.target.value }
    })
  }
  const handleSubmit = () => {
    setSendingState("sending")
    fetch(
      `https://script.google.com/macros/s/AKfycbyHuLXkXuU5ZG1sU0N7hLyO5sq5iiNIwmjOR6w/exec?name=${formState.name}&mail=${formState.email}&text=${formState.body}`,
      {
        method: "POST",
        body: JSON.stringify({ title: "React POST Request Example" }),
      }
    )
      .then(_res => setSendingState("done"))
      .catch(err => console.log(err))
  }
  return (
    <Container maxWidth="md">
      <Typography variant="h1" className={classes.title}>
        Lust auf Volleyball bekommen ?
      </Typography>
      <Card className={classes.card}>
        {sendingState !== "done" ? (
          <>
            <TextField
              disabled={sendingState === "sending"}
              className={classes.textField}
              fullWidth
              required
              id="name"
              label="Dein Name"
              placeholder="Max Mustermann"
              onChange={handleFormFieldChange}
            />
            <TextField
              disabled={sendingState === "sending"}
              className={classes.textField}
              fullWidth
              required
              id="email"
              label="Deine Email"
              placeholder="max.mustermann@mail.de"
              onChange={handleFormFieldChange}
            />
            <TextField
              disabled={sendingState === "sending"}
              className={classes.textField}
              fullWidth
              multiline
              rows={6}
              id="body"
              label="Deine Frage"
              placeholder="Schreib uns was nettes :)"
              onChange={handleFormFieldChange}
            />
          </>
        ) : (
          <Typography variant="h4">
            Wir haben deine Anfrage erhalten und werden uns schnellstmöglich bei
            dir melden.
          </Typography>
        )}

        {sendingState !== "done" && (
          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              className={classes.button}
              disabled={sendingState === "sending"}
              endIcon={
                sendingState === "sending" && (
                  <CircularProgress size="1.5rem" color="inherit" />
                )
              }
              onClick={() => handleSubmit()}
            >
              {sendingState === "initial" ? "Absenden" : "Wird versendet"}
            </Button>
          </Box>
        )}
      </Card>
    </Container>
  )
}
